import {gql} from '@apollo/client';
import {Row} from 'antd';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {Address, Artist} from 'src/components';
import MasonryGrid from './MasonryGrid';
import {ArtistFragment} from './__generated__/ArtistFragment';

export const GqlArtistFragment = gql`
  fragment ArtistFragment on Artist {
    id
    uri
    name
    mintedAt
    description
    imageUri
    creationReadyAt
    owner {
      id
    }
  }
`;

type ArtistsProps = {
  artists?: ArtistFragment[];
  showExtraInfo?: boolean;
  maxColumns?: number;
};

export default function Artists(props: ArtistsProps) {
  return (
    <>
      <Row gutter={[16, 16]}>
        {props.artists && (
          <TransitionGroup component={null}>
            <MasonryGrid maxColumns={props.maxColumns}>
              {props.artists.map((a) => {
                return (
                  <CSSTransition
                    key={a.id}
                    component={null}
                    classNames={{
                      enterActive: 'animate__animated animate__lightSpeedInLeft',
                      exitActive: 'animate__animated animate__lightSpeedOutRight',
                    }}
                    timeout={900}>
                    <Artist {...a}>
                      {props.showExtraInfo && a.owner?.id && (
                        <div>
                          <br />
                          Owner: <Address address={a.owner.id} size='small' isLinked />
                        </div>
                      )}
                    </Artist>
                  </CSSTransition>
                );
              })}
            </MasonryGrid>
          </TransitionGroup>
        )}
      </Row>
    </>
  );
}
